import ModalResponsive from '@/components/commons/modal-responsive';
import CardPromotion from '@/components/sections/builder/elements/body/product-detail/components/card-promotion';
import useModal from '@/hooks/useModal';
import { cn, hexToRgba, isEmpty } from '@/lib/utils';
import { ThemeColorSchemeType } from '@/stores/builder';
import { BasePromotion } from '@/types/http/promotion/common';
import { ChevronRight, Ticket } from 'lucide-react';

type ModalPromotionProductProps = {
  theme?: ThemeColorSchemeType;
  listPromotion?: BasePromotion[];
};

export default function ModalPromotionProduct({
  theme,
  listPromotion,
}: ModalPromotionProductProps) {
  const modalListPromotion = useModal();

  return (
    <>
      <div
        className={cn(
          'group relative mx-auto flex w-full max-w-xl cursor-pointer items-center justify-between gap-3 rounded-lg px-4 py-2.5 transition-all duration-300 hover:opacity-80',
          isEmpty(theme) ? 'bg-gray-100' : 'bg-[var(--background)]'
        )}
        role='button'
        onClick={modalListPromotion.open}
        style={
          {
            '--background': hexToRgba(theme?.background, 0.1) || '#f3f4f6',
            '--text-primary': theme?.text || '#111827',
            '--text-secondary': theme?.textSecondary || '#6b7280',
            '--btn-background': theme?.btnSolidBackgroud || '#000000',
            '--btn-label': theme?.btnSolidlabel || '#ffffff',
          } as React.CSSProperties
        }
      >
        {/* Icon Tiket */}
        <div className='flex flex-shrink-0 items-center justify-center'>
          <Ticket
            className={cn(
              'size-7 sm:size-8',
              isEmpty(theme) ? 'text-gray-500' : 'text-[var(--text-primary)]'
            )}
            strokeWidth={1.2}
          />
        </div>

        {/* Text Content */}
        <div className='flex flex-1 flex-col text-left'>
          <h3 className='text-sm font-bold text-gray-900'>
            You have{' '}
            <span className={cn(isEmpty(theme) ? 'text-orange-500' : 'text-[var(--text-primary)]')}>
              {listPromotion?.length} Discount
            </span>{' '}
            available
          </h3>
          <p className='text-xs text-gray-600'>Use your coupon now for exciting offers!</p>
        </div>

        {/* Icon Chevron */}
        <div className='flex flex-shrink-0 items-center justify-center'>
          <ChevronRight
            className='size-5 text-[var(--text-secondary)] sm:size-6'
            strokeWidth={2.5}
          />
        </div>
      </div>

      <ModalResponsive
        openModal={modalListPromotion.isShow}
        title='DISCOUNTS'
        setOpenModal={modalListPromotion.setIsShow}
        className='max-w-xl !rounded-none'
      >
        <div className='flex max-h-[350px] flex-col gap-3 px-7 py-2'>
          <div className='mb-2 space-y-3 overflow-y-auto pr-2'>
            {(listPromotion ?? []).length > 0 ? (
              listPromotion?.map((promo) => (
                <CardPromotion key={promo.promotion_id} promo={promo} theme={theme} />
              ))
            ) : (
              <div className='flex items-center justify-center p-4'>
                <div className='text-sm text-gray-500'>No discount available</div>
              </div>
            )}
          </div>
        </div>
      </ModalResponsive>
    </>
  );
}
